import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';

import { ThemeProvider } from 'react-bootstrap';
import { UserProvider } from './hooks/UserProvider';

import App from './App';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ThemeProvider breakpoints={['xxxl', 'xxl', 'xl', 'lg', 'md', 'sm', 'xs', 'xxs']}>
    <UserProvider>
      <App />
    </UserProvider>
  </ThemeProvider>
);
